class LWSearch extends HTMLElement {
    constructor() {
        super();
        this.attachShadow({ mode: 'open' });
    }

    connectedCallback() {
        this.render();
    }

    render() {
        this.shadowRoot.innerHTML = /* html */ `
        <style>
            :host {
                display: block;
                margin-bottom: 20px;
            }
            .search-wrapper {
                position: relative;
                display: flex;
                align-items: center;
            }
            input {
                width: 100%;
                padding: 12px 40px 12px 15px;
                border: 2px solid #eee;
                border-radius: 8px;
                font-size: 1rem;
                outline: none;
                transition: border-color 0.2s;
            }
            input:focus {
                border-color: var(--my-card-accent, #007bff);
            }
            .clear-btn {
                position: absolute;
                right: 10px;
                cursor: pointer;
                display: none;
                background: #ccc;
                color: white;
                border-radius: 50%;
                width: 20px;
                height: 20px;
                text-align: center;
                line-height: 18px;
                font-size: 12px;
            }
        </style>
        <div class="search-wrapper">
            <input type="text" placeholder="Zoeken door systeem...">
            <div class="clear-btn">&times;</div>
        </div>
        `;

        const input = this.shadowRoot.querySelector('input');
        const clearBtn = this.shadowRoot.querySelector('.clear-btn');

        // Luister naar typen
        input.addEventListener('input', (e) => {
            const value = e.target.value.toLowerCase();
            clearBtn.style.display = value ? 'block' : 'none';

            // STAP 1: Schiet een 'custom event' af die de rest van de pagina kan horen
            this.dispatchEvent(new CustomEvent('lw-filter', {
                detail: { query: value },
                bubbles: true,
                composed: true
            }));
        });

        clearBtn.addEventListener('click', () => {
            input.value = '';
            input.dispatchEvent(new Event('input'));
            input.focus();
        });
    }
}
customElements.define('lw-search', LWSearch);